<template>
  <div class="yh-page">
    <el-card v-loading="loading" :element-loading-text="loadingText">
      <el-row
        slot="header"
        type="flex"
        justify="start"
        align="middle"
        class="p-3"
        :gutter="10"
      >
        <el-col :span="5">
          <el-input
            placeholder="输入名称进行搜索..."
            v-model.trim="query.search"
            @keyup.enter.native="handleSearch"
          >
          </el-input>
        </el-col>
        <el-col>
          <el-select
            v-model="query.ocr_status"
            placeholder="请选择状态"
            clearable
            style="width: 150px"
          >
            <el-option
              v-for="item in status_list"
              :key="item.code"
              :label="item.label"
              :value="item.code"
            >
            </el-option>
          </el-select>
          &nbsp;
          <el-date-picker
            v-model="file_selector.date_range"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="2">
          <el-button
            type="info"
            icon="el-icon-search"
            :loading="searching"
            @click="handleSearch"
            >搜索</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-upload
            class="my-upload"
            action=""
            multiple
            ref="uploadRef"
            :accept="accept"
            :http-request="uploadFile"
            :file-list="fileList"
            :show-file-list="true"
            :auto-upload="true"
            :on-change="handleFileChange"
            v-loading="fileLoading"
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="`只能上传${accept}文件，且不超过10MB`"
              placement="top"
            >
              <el-button type="primary" icon="el-icon-upload">上传</el-button>
            </el-tooltip>
          </el-upload>
          <!-- <el-button type="primary" icon="el-icon-upload">上传</el-button> -->
          <!-- <el-button type="primary" icon="el-icon-download">打包下载</el-button> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button type="primary" size="mini" @click="selectAllType"
            >全选</el-button
          >
          <el-button size="mini" @click="resetAllType">全不选</el-button>
          <el-tree
            :data="type_list"
            show-checkbox
            node-key="code"
            ref="tree"
            highlight-current
            @check-change="handleSelectType"
          >
          </el-tree>
        </el-col>
        <el-col :span="20">
          <el-table
            :key="0"
            :data="list"
            stripe
            v-loading="loading"
            :element-loading-text="loadingText"
            fit
            highlight-current-row
            @selection-change="handleSelectionChange"
            class="w-100 mt-2"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <!-- 文件名称 -->
            <el-table-column align="left" label="文件名">
              <template slot-scope="scope">
                <template v-if="false">
                  <span
                    class="text-link"
                    v-preview="scope.row.url"
                    :alt="scope.row.name"
                    preview-title-enable="true"
                    preview-nav-enable="true"
                    v-show="!isPdfFile(scope.row.name)"
                    >{{ scope.row.name }}</span
                  >
                  <span
                    class="text-link"
                    @click="previewPdf(scope.row)"
                    v-show="isPdfFile(scope.row.name)"
                    >{{ scope.row.name }}</span
                  >
                  <span class="ml-1">
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="重命名"
                      placement="top-start"
                    >
                      <el-button
                        v-show="!scope.row.display_rename"
                        size="mini"
                        type="text"
                        @click="handleOpenRename(scope.row)"
                        ><i class="el-icon-edit"></i
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="确定"
                      placement="top-start"
                    >
                      <el-button
                        v-show="scope.row.display_rename"
                        size="mini"
                        type="text"
                        @click="handle_rename(scope.row)"
                        ><i class="el-icon-check"></i
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="取消"
                      placement="top-start"
                    >
                      <el-button
                        v-show="scope.row.display_rename"
                        size="mini"
                        type="text"
                        @click="$set(scope.row, 'display_rename', false)"
                        ><i class="el-icon-close"></i
                      ></el-button>
                    </el-tooltip>
                  </span>
                  <file-rename
                    :ref="'rename' + scope.row.id"
                    object-type="ship.ship"
                    :file-type-list="file_type_list"
                    :object-name="fd.name"
                    :cert-file="scope.row"
                    :visible="scope.row.display_rename === true"
                  ></file-rename>
                </template>
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <!-- 文件原名 -->
            <el-table-column align="left" label="文件原名">
              <template slot-scope="scope">
                <span>{{ scope.row.original_name }}</span>
              </template>
            </el-table-column>
            <!-- 文件大小 -->
            <el-table-column
              min-width="20%"
              align="left"
              label="文件大小"
              prop="size"
              sortable
            >
              <template slot-scope="scope">
                <span>{{ scope.row.size | formatSize }}</span>
              </template>
            </el-table-column>
            <!-- 创建时间 -->
            <el-table-column
              min-width="40%"
              align="left"
              label="创建时间"
              prop="create_time"
              sortable
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.create_time | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                }}</span>
              </template>
            </el-table-column>
            <!-- 识别状态 -->
            <el-table-column
              min-width="20%"
              align="left"
              label="识别状态"
              prop="size"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" placement="left">
                  <div
                    slot="content"
                    v-html="scope.row.ocr_result.report"
                    style="white-space: pre-wrap"
                  ></div>
                  <span>{{ getStatusName(scope.row.ocr_status) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 按钮组 -->
            <el-table-column
              align="left"
              label="操作"
              min-width="20%"
              class-name="small-padding fixed-width"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="light"
                  content="删除"
                  placement="top-start"
                >
                  <el-button type="text" @click="handleDelete(scope.row)"
                    ><i class="el-icon-delete"></i
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="下载"
                  placement="top-start"
                >
                  <el-button type="text" @click="handleDownload(scope.row)"
                    ><i class="el-icon-download"></i
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="证书数据"
                  placement="top-start"
                >
                  <el-button type="text" @click="handleCertInfo(scope.row)"
                    ><i class="el-icon-folder-opened"></i
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="关联船舶"
                  placement="top-start"
                >
                  <el-button type="text" @click="handleConnectShip(scope.row)"
                    ><i class="el-icon-connection"></i
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="查看"
                  placement="top-start"
                >
                  <el-button type="text" @click="handleEdit(scope.row)"
                    ><i class="el-icon-view"></i
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            ref="pagination"
            :size.sync="query.limit"
            :offset.sync="query.offset"
            :total="total"
            @updateList="getList"
          ></pagination>
        </el-col>
      </el-row>
    </el-card>

    <common-form ref="cert_info"></common-form>
    <pdf-editor ref="pdfEditor"></pdf-editor>
    <image-editor ref="imageEditor"></image-editor>
    <file-import-dialog
      ref="fileImportDialog"
      :file-id="file_id"
      :ww-file-info="wwFileInfo"
      :cert-file="certFile"
      @update-relation-success="handleImportSuccess"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import CommonForm from "@/components/CommonForm/CertDataProcessor.vue";
import { getTypeFileList, fetchFileTypeList } from "@/api/common";
import { getDocuments } from "@/api/wechat";
import { uploadCertFile } from "@/api/upload";
import { formatSize } from "@/utils/misc";
import { downloadFile, removeFile, rename } from "@/api/upload";
import FileImportDialog from "@/components/FileProcessor/FileImportDialog.vue";
import PdfEditor from "@/components/FileProcessor/PdfEditor";
import ImageEditor from "@/components/FileProcessor/ImageEditor.vue";

export default {
  name: "document-list",
  filters: {
    formatSize,
  },
  components: {
    FileImportDialog,
    Pagination,
    CommonForm,
    PdfEditor,
    ImageEditor,
  },
  data() {
    return {
      query: {
        limit: 10,
        offset: 0,
        ocr_status: "",
        search: "",
      },
      file_selector: {
        file_type: "",
      },
      loadingText: "正在加载数据，请稍等...",
      loading: false,
      searching: false,
      groupList: [],
      total: 0,
      list: [],
      multipleSelection: [],
      type_list: [],
      use_types: { file_type: "sc" }, // 该变量控制文件类型菜单栏选项及页面数据文件类型，为{}是所示全类型
      no_type: { code: "null_type", label: "未分类" },
      accept: ".png,.jpg,.jpeg,.pdf",
      file_id: null,
      isDialogReady: false,
      fileList: [],
      fileLoading: false,
      status_list: [
        { code: "-1", label: "识别中" },
        { code: "1", label: "已识别" },
        { code: "3", label: "已确认" },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      wwFileInfo: null,
      certFile: {},
    };
  },
  methods: {
    getStatusName(code) {
      let name = "";
      for (let item of this.status_list) {
        if (item.code === code) {
          name = item.label;
          break;
        }
      }
      return name;
    },
    handleSearch() {
      // this.getList()
      this.$refs.pagination.backNumOne();
    },
    // 后端返回文件类型列表格式化函数
    handleTypeList(org_list) {
      let res = [];
      let file_type_list = [];

      org_list.forEach((item) => {
        let index = file_type_list.indexOf(item.file_type);
        if (index !== -1) {
          res[index].children.push({ code: item.code, label: item.name });
        } else {
          let dict = {
            code: index,
            label: item.file_type,
            children: [{ code: item.code, label: item.name }],
          };
          res.push(dict);
          file_type_list.push(item.file_type);
        }
      });
      res.push(this.no_type);
      return res;
    },
    loaddata() {
      this.loading = true;
      let p = [];
      p.push(fetchFileTypeList(this.use_types));

      Promise.all(p)
        .then((res) => {
          this.type_list = this.handleTypeList(res[0]);
        })
        .then(() => {
          this.selectAllType();
        })
        .then(() => {
          this.getList();
        })
        .catch((err) => {
          this.$error_message(err);
        });
    },
    getList() {
      this.loading = true;
      getDocuments(this.query, this.file_selector)
        .then((res) => {
          this.list = res.results;
          this.total = res.count;
        })
        .catch((err) => {
          this.$message.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectAllType() {
      let types = [this.no_type.code];
      this.type_list.forEach((type) => {
        if (type.children) {
          type.children.forEach((t) => {
            types.push(t.code);
          });
        } else {
          types.push(type.code);
        }
      });
      this.$refs.tree.setCheckedKeys(types);
      this.handleSelectType();
    },
    resetAllType() {
      this.$refs.tree.setCheckedKeys([]);
      this.handleSelectType();
    },
    // 将菜单栏勾选文件类型传递至参数
    handleSelectType(data, checked, indeterminate) {
      let checked_keys = this.$refs.tree.getCheckedKeys();
      if (checked_keys.length === 0) {
        this.file_selector.file_type = "";
      } else if (checked_keys.length > 0) {
        this.file_selector.file_type = checked_keys.join("|");
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete(file) {
      removeFile(file.id)
        .then(() => {
          this.getList();
        })
        .catch((error) => {
          this.$error_message(error);
        });
    },
    handleDownload(file) {
      downloadFile(file.id)
        .then((res) => {
          let link = document.createElement("a");
          link.style.display = "none";

          let blob = new Blob([res]);
          link.href = URL.createObjectURL(blob);

          link.download = file.name;
          document.body.appendChild(link);

          link.click();
          URL.revokeObjectURL(blob);
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.$error_message(error);
        });
    },
    handleCertInfo(file) {
      this.$refs.cert_info.handleOpen(file);
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList;
    },
    // 文件上传
    uploadFile(file) {
      // 避免多次请求 获取上传文件的长度 与 fileList的长度相等时才请求
      this.$nextTick(() => {
        let uploadlist = document.querySelectorAll(
          ".my-upload .el-upload-list.el-upload-list--text .el-upload-list__item"
        );
        let maxLen = uploadlist.length; // 上传文件数量
        let limit = 15; // 限制上传文件数量
        let errorFlag = false;
        // 判断当前文件是否是最后一个文件
        if (this.fileList.length === maxLen) {
          // 上传文件数量大于限制数量
          if (maxLen > limit) {
            this.$message({
              type: "warning",
              message: `最多上传${limit}个文件`,
            });
            this.$set(this, "fileList", []);
            this.$refs.uploadRef.clearFiles();
            return;
          }
          this.fileLoading = true;
          const formData = new FormData();
          for (let i = 0; i < this.fileList.length; i++) {
            let raw = this.fileList[i].raw;
            let ext_list = this.fileList[i].name.split(".");
            if (this.accept.indexOf(ext_list[ext_list.length - 1]) === -1) {
              console.log(this.fileList[i].name, ext_list[ext_list.length - 1]);
              errorFlag = true;
            }
            formData.append("fileList", raw);
          }

          // 清空文件列表
          this.$set(this, "fileList", []);
          // 格式错误提示
          if (errorFlag) {
            this.$message({
              type: "warning",
              message: `文件格式不正确,请使用${this.accept}格式文件`,
            });
            this.$refs.uploadRef.clearFiles();
            this.fileLoading = false;
            return;
          }
          uploadCertFile(formData)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("上传成功");
              } else {
                this.$message.error("上传失败");
              }
            })
            .catch((err) => {
              this.$message.error("上传失败");
              console.error("err:", err);
            })
            .finally(() => {
              // 上传成功后清空文件列表
              this.$refs.uploadRef.clearFiles();
              this.fileLoading = false;
              this.getList();
            });
        }
      });
    },
    handleConnectShip(item) {
      const name = item.name;
      const ext = item.ext_type;
      const size = item.size;
      const uid = Math.random().toString(36).substr(2, 9);
      this.certFile = {
        extension: ext,
        name: name,
        new_name: "",
        raw: "",
        percentage: 0,
        sel_sub_certtype: [],
        size: size,
        status: "ready",
        uid: uid,
      };
      this.wwFileInfo = null;
      this.file_id = item.id;

      // 确保 fileImportDialog 存在并且可以打开
      if (this.$refs.fileImportDialog) {
        this.$refs.fileImportDialog.open();
      } else {
        console.error("fileImportDialog not found"); // 添加错误日志
      }
    },
    handleImportSuccess(data) {
      // 确保在成功导入后刷新列表
      this.$nextTick(() => {
        this.getList(); // 调用获取列表方法
      });
      this.$message.success("关联成功");
    },
    // 判断文件是否可编辑
    isEditableFile(file) {
      if (!file) return false;
      const validExtensions = [".jpg", ".jpeg", ".png", ".gif", ".pdf"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      return validExtensions.includes(`.${fileExtension}`);
    },

    // 处理编辑操作
    handleEdit(file) {
      if (this.isEditableFile(file)) {
        const adapterFile = {
          filename: file.name,
          filepath: file.url,
        };
        if (/\S+\.(pdf)$/.test(file.name.toLowerCase())) {
          this.$refs.pdfEditor.show(adapterFile, true);
        } else {
          this.$refs.imageEditor.show(adapterFile, true);
        }
      } else {
        this.$error_message("不支持编辑该文件类型");
      }
    },

    // 处理图片编辑
    handleImageEdit(fileInfo) {
      this.$refs.imageEditor.show(fileInfo);
    },

    // 处理PDF编辑
    handlePdfEdit(fileInfo) {
      this.$refs.pdfEditor.show(fileInfo);
    },
  },
  created() {
    this.loaddata();
    // this.getList()
  },
};
</script>
